import React from 'react';
import PropTypes from 'prop-types';
import TextInput from './TextInput'
import { Alert } from 'reactstrap'
import { Formik, Form, Field } from 'formik'
import { faPaperPlane } from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import Button from './CustomButton'
import { set } from 'lodash'
import { compose, setDisplayName } from 'recompose'
import NextForm from '../containers/NextForm'

const initialValues = currentStaff => currentStaff ?
  {
    user_attributes: currentStaff.user,
    job_title: currentStaff.job_title,
  } :
  {
    user_attributes: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: ''
    },
    job_title: ''
  }

export const StaffForm = (props) => {
  const {
    failSubmitStaff,
    submittingStaff,
    onSubmit,
    currentStaff,
    inputs,
    focusNextField
  } = props
  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues(currentStaff)}
      render={(props) => (
        <Form>
          {failSubmitStaff && <Alert color='danger'>{failSubmitStaff}</Alert>}
          <Field
            innerRef={r => inputs.first_name = r}
            onKeyPress={focusNextField('last_name')}
            name='user_attributes.first_name'
            component={TextInput}
            placeholder="Staff's First Name"
            label="First Name" />
          <Field
            innerRef={r => inputs.last_name = r}
            onKeyPress={focusNextField('email')}
            name='user_attributes.last_name'
            component={TextInput}
            placeholder="Staff's Last Name"
            label="Last Name" />
          <Field
            innerRef={r => inputs.email = r}
            onKeyPress={focusNextField('phone_number')}
            name='user_attributes.email'
            type='email'
            component={TextInput}
            placeholder="Staff's Email"
            label="Email" />
          <Field
            innerRef={r => inputs.phone_number = r}
            onKeyPress={focusNextField('job_title')}
            name='user_attributes.phone_number'
            type='tel'
            component={TextInput}
            placeholder="Staff's Phone Number"
            label="Phone Number" />
          <Field
            innerRef={r => inputs.job_title = r}
            name='job_title'
            component={TextInput}
            placeholder="Staff's Job Title"
            label="Job Title" />
          <div>
            <Button
              fill
              type="submit"
              disabled={submittingStaff}
              color="primary">
              {currentStaff ? 'Update' : 'Create'} Staff <FontAwesomeIcon icon={faPaperPlane} />
            </Button>
          </div>
        </Form>
      )} />
  )
}

StaffForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submittingStaff: PropTypes.bool.isRequired,
  failSubmitStaff: PropTypes.string,
  currentStaff: PropTypes.object
}

export const validate = (values = { user_attributes: {} }) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
  const errors = {}
  if (!values.user_attributes.first_name) {
    set(errors, 'user_attributes.first_name', 'Required')
  }
  if (!values.user_attributes.email) {
    set(errors, 'user_attributes.email', 'Required')
  } else if (!emailRegex.test(values.user_attributes.email)) {
    set(errors, 'user_attributes.email', 'Invalid email')
  }
  if (!values.user_attributes.last_name) {
    set(errors, 'user_attributes.last_name', 'Required')
  }
  if (!values.job_title) {
    errors.job_title = 'Required'
  }
  if (!values.user_attributes.phone_number) {
    set(errors, 'user_attributes.phone_number', 'Required')
  }
  return errors
}

export default compose(
  setDisplayName('StaffForm'),
  NextForm
)(StaffForm)
